import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RequestOpeningTemplateService {
	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	private templateUrl = environment.baseApiUrl + 'register/selfserviceCatalog/template';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getAvailableTemplates(): Observable<templateReworkInterface[]> {
		return this.http.get(this.templateUrl, { headers: this.headers }).pipe(
			map((templates: any[]) => {
				const newTemplateArray: templateReworkInterface[] = [];
				for (const template of templates) {
					const newTemplate: templateReworkInterface = {
						id: template.id,
						name: template.name,
						summary: template.summary,
						description: template.description,
						informative: template.informative,
						service_type: template.service_type,
						scope: template.scope,
						category: template.category,
						topic: template.topic,
						solution_area: template.solution_area,
						severity: template.severity,
						description_required: template.description_required,
						confidential_request: template.confidential_request,
					};

					newTemplateArray.push(newTemplate);
				}

				return newTemplateArray;
			})
		);
	}

	createTemplate(template: templateReworkInterface): Observable<templateReworkInterface> {
		return this.http.post<templateReworkInterface>(this.templateUrl, template, { headers: this.headers });
	}

	updateTemplate(template: templateReworkInterface): Observable<templateReworkInterface> {
		return this.http.put<templateReworkInterface>(this.templateUrl, template, { headers: this.headers });
	}

	deleteTemplate(idTemplate: string): Observable<any> {
		const deleteTemplateUrl = this.templateUrl + '?id=' + idTemplate;
		return this.http.delete<any>(deleteTemplateUrl, { headers: this.headers });
	}
}
